import { RoleUniqueNames } from '@melio/platform-api';

const ADMINS: Partial<RoleUniqueNames>[] = [
  RoleUniqueNames.MelioOwner,
  RoleUniqueNames.MelioAdmin,
  RoleUniqueNames.CapitalOnePrimary,
];

export const isAdmin = (roleUniqueName: RoleUniqueNames) => ADMINS.includes(roleUniqueName);
